const getValue = (record, keys, fallback = '') =>
  keys
    .map((key) => record?.[key])
    .find((value) => value !== undefined && value !== null && value !== '') ??
  fallback

export const calculateInvoiceSummary = (order, items) => {
  const original = {
    grossTotal:
      Number(
        getValue(order, ['grosstotal', 'grossTotal', 'total_amount'], 0),
      ) || 0,
    discountTotal:
      Number(getValue(order, ['discount', 'discountTotal'], 0)) || 0,
    NetTotal:
      Number(getValue(order, ['nettotal', 'netTotal', 'amount_payable'], 0)) ||
      0,
  }
  const returned = items.reduce(
    (totals, item) => {
      const quantity =
        Number(
          getValue(
            item,
            ['totalReturned', 'totalreturned', 'returned_quantity'],
            0,
          ),
        ) || 0
      const unitCost =
        Number(
          getValue(item, ['unitCost', 'unitprice', 'unitPrice', 'unitcost'], 0),
        ) || 0
      const discount =
        Number(getValue(item, ['discount', 'discount_percent'], 0)) || 0
      const discountRate =
        discount > 0 && discount < 1 ? discount : discount / 100
      const gross = quantity * unitCost
      const discountAmount = gross * discountRate

      return {
        grossTotal: totals.grossTotal + gross,
        discountTotal: totals.discountTotal + discountAmount,
        NetTotal: totals.NetTotal + gross - discountAmount,
      }
    },
    { grossTotal: 0, discountTotal: 0, NetTotal: 0 },
  )

  return {
    original,
    returned,
    afterReturn: {
      grossTotal: Math.max(0, original.grossTotal - returned.grossTotal),
      discountTotal: Math.max(
        0,
        original.discountTotal - returned.discountTotal,
      ),
      NetTotal: Math.max(0, original.NetTotal - returned.NetTotal),
    },
    hasReturns: items.some(
      (item) =>
        Number(
          getValue(
            item,
            ['totalReturned', 'totalreturned', 'returned_quantity'],
            0,
          ),
        ) > 0,
    ),
  }
}
